import styles from 'src/js/common/components/formatters/ListFormatter.less';
import baseListFormatterItemParams from 'src/js/lib/raw_rendering/base_list_formatter_item_params';

/**
 * Returns raw Html version of MarkerListFormatterItem component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function listFormatterItemRenderer(params, services = {}) {
  const {label, title} = baseListFormatterItemParams(params, services);

  return `<div class="${styles.dlListItem}" title="${title}">
            ${label}
        </div>`;
}
